<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-divider />
    <a-card class="search-card" :bordered="false">
      <span>科目：</span>
      <j-dict-select-tag
        :defaultShowAll="true"
        type="list"
        @change="handleChangeType"
        v-model="paperType"
        :trigger-change="true"
        dictCode="paper_type"
        style="width: 200px"
      />
      <a-divider type="vertical"></a-divider>
      <span>级别：</span>
      <j-dict-select-tag style="width:200px" placeholder="请选择难度" @change="getPaperList()" v-model="paperDiff" dictCode="paper_difficulty" />
      <!--
      <a-select
        placeholder="请选择"
        v-model="paperDiff"
        @change="getPaperList()"
        style="width: 200px"
      >
        <a-select-option :value="undefined">请选择</a-select-option>
        <a-select-option :value="1">易</a-select-option>
        <a-select-option :value="2">中</a-select-option>
        <a-select-option :value="3">难</a-select-option>
      </a-select>
      -->

      <div style="float: right">
        <span>试卷编号：</span>
        <a-input-search
          v-model="paperId"
          style="width: 200px"
          @search="getPaperList"
        ></a-input-search>
      </div>
    </a-card>
    <a-divider />
    <a-card :bordered="false">
      <a-list :dataSource="paperDataSource" :pagination="pagination">
        <a-list-item slot="renderItem" slot-scope="item">
          <h3>
            <a-tag>{{ item.paperType_dictText }}</a-tag
            >{{ item.paperName }}
          </h3>
          <div slot="actions">
            <a-tag v-if="!_isMobile()"
              >考试时间 {{ item.timeLimit }} 分钟</a-tag
            >
            <a-tag v-if="!_isMobile()">总分 {{ item.totalScore }} 分</a-tag>
            <a-tag v-if="!_isMobile()"
              >限次：{{ item.mySubmitTimes ? item.mySubmitTimes + "/" : ""
              }}{{
                item.submitTimesLimit == -1 ? "不限" : item.submitTimesLimit
              }}</a-tag
            >
            <a-button
              class="to-exam-btn"
              type="primary"
              v-if="
                item.userPaperStatus > 0 &&
                (item.submitTimesLimit == -1 ||
                  item.submitTimesLimit > item.mySubmitTimes)
              "
              size="small"
              @click="toPaper(item, true)"
              >再次考试</a-button
            >
            <a-divider type="vertical" />
            <a-button
              type="primary"
              size="small"
              @click="toPaper(item, false)"
            >
              {{
                item.userPaperStatus == 0
                  ? "继续考试"
                  : item.userPaperStatus == 1 || item.userPaperStatus > 1
                  ? "查看答卷"
                  : "去考试"
              }}
              <a-icon type="right"
            /></a-button>
            <!-- <a-button v-if="item.userPaperStatus==null||item.userPaperStatus==0" class="to-exam-btn" size="small" @click="toDetail(item.id || item.paperId)">参加考试<a-icon type="right"/></a-button>
                  <a-button v-if="item.userPaperStatus>0" class="to-exam-btn" size="small">已交卷<a-icon type="right"/></a-button> -->
          </div>
        </a-list-item>
      </a-list>
    </a-card>

    <!--支付弹窗 -->
    <template>
      <div>
        <a-spin :spinning="createLoading" size="large">
          <a-modal
              title="扫码支付"
              :width="800"
              :visible="vipVisible"
              :confirmLoading="confirmLoading"
              @cancel="handleCancel"
              cancelText="关闭"
              @ok="handleOk"
              okText="我已完成支付?"
              wrapClassName="ant-modal-cust-warp"
              style="top:5%;height: 85%;overflow-y: hidden">

            <div class="payment-info">
              <span class="vip-level">该试卷需要的会员的等级：{{ vipLevel.vipName }}</span>
              <span class="vip-price">价格：{{ vipLevel.price / 100 }}￥</span>
            </div>

            <div class="qr-code-container">
              <div class="qr-code-header">
                <img src="@/assets/wxlogo.png" class="wx-logo" />
              </div>
              <div class="qr-code-body">
                <canvas ref="qrcodeCanvas"></canvas>
                <div>请使用微信扫码二维码完成支付</div>
              </div>
            </div>
          </a-modal>
        </a-spin>
      </div>

    </template>
  </div>
</template>
  
  <script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction,postAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import { Modal, Spin, Button, message } from 'ant-design-vue';
var QRCode = require('qrcode')
var canvas = ''

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    'a-modal': Modal,
    'a-spin': Spin,
    'a-button': Button,
  },
  data() {
    return {
      paperDataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: this._isMobile() ? 12 : 15,
      },
      loading: true,
      paperId: "",
      paperType: "",
      paperDiff: undefined,
      token: "",
      tenantConfig: {},
      visible: false,
      vipVisible: false,
      createLoading: false,
      vipLevel:{},
      payUrl: '',
      confirmLoading: false,
    };
  },
  created() {
    if (Vue.ls.get(ACCESS_TOKEN)) {
      this.token = Vue.ls.get(ACCESS_TOKEN);
    }
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if(this.$route.query.type){
      this.paperType = this.$route.query.type
    }
    this.getPaperList();
  },
  mounted() {
    // window.document.title = this.tenantConfig.brandName + " " + "题库";
  },
  methods: {
    handleChangeType(v) {
      
      this.paperType = v
      this.getPaperList();
    },
    getPaperList() {
      this.loading = true;
      this.paperDataSource = [];
      if (this.token) {
        getAction("/teaching/teachingPaper/minePaperList", {
          id: this.paperId,
          paperType: this.paperType,
          paperDifficulty: this.paperDiff,
          pageSize: 999,
        }).then((res) => {
          if (res.success) {
            this.paperDataSource = this.paperDataSource.concat(res.result);
            this.duplicateRemove();
          }
          this.loading = false;
        });
      }
      getAction("/teaching/teachingPaper/showPaper", {
        id: this.paperId,
        paperType: this.paperType,
        paperDifficulty: this.paperDiff,
        pageSize: 999,
      }).then((res) => {
        if (res.success) {
          this.paperDataSource = this.paperDataSource.concat(
            res.result.records
          );
          this.duplicateRemove();
        }
        this.loading = false;
      });
    },
    duplicateRemove() {
      let ids = [];
      for (let i in this.paperDataSource) {
        let paperId;
        if ("paperId" in this.paperDataSource[i]) {
          paperId = this.paperDataSource[i].paperId;
        } else {
          paperId = this.paperDataSource[i].id;
        }
        if (ids.includes(paperId)) {
          //删除重复
          this.paperDataSource.splice(i, i);
        } else {
          ids.push(paperId);
        }
      }
      console.log(ids);
    },
    toDetail(id) {
      // window.location.href = config.adminUrl + `/teaching/minePaper/list?token=${this.token}`
      //window.location.href = config.adminUrl + `examine?id=${id}&token=${this.token}`
      this.$router.push({
        path: "/examine",
        query: {
          id: id,
        },
      });
    },
    toPaper(info, redo) {
      console.log(info)
      //校验当前用户是否有权限
      getAction("/teaching/teachingPaper/checkPaperPermission", {
        paperId: info.id
      }).then(res => {
        if (res.success) {
          console.log(res.result)
          //如果没有考试权限执行去购买逻辑
          if (res.result == 2) {
            console.log("执行去购买逻辑")
            this.showPurchaseModal(info.id)
          } else {
            let that = this;
            if (info.userPaperStatus == null) {
              this.$confirm({
                title: "提示",
                content: "确定参加考试吗? 开始后不可暂停考试",
                onOk() {
                  if (redo) {
                    that.redoExam(info);
                  } else {
                    that.toExam(info);
                  }
                },
                onCancel() { },
              });
            } else {
              if (redo) {
                that.redoExam(info);
              } else {
                that.toExam(info);
              }
            }
          }
        }
      });

    },
    showPurchaseModal(paperId) {
      Modal.confirm({
        title: '您暂未有该试卷权限，是否购买会员？',
        okText: '去购买',
        cancelText: '关闭',
        onOk: () => {
          // 设置加载状态为 true
          this.createLoading = true;
          // 处理去购买的逻辑
          this.goToPurchasePage(paperId);
        },
        onCancel: () => {
          // 处理关闭逻辑
          console.log('关闭弹窗');
        },
      });
    },

    async goToPurchasePage(paperId) {
      // 跳转到购买页面的逻辑
      console.log('去购买页面');
      try{
        await this.getVipLevelByPaperId(paperId);
      } finally{
        this.createLoading = false;
      }
      
    },
    handleCancel () {
      this.closeVip()
    },
    handleOk () {
      this.closeVip()
      // 刷新页面
      window.location.reload();
    },
    closeVip () {
      this.$emit('close');
      this.vipVisible = false;
    },
        //根据试卷id查询所需要的vip等级
    async getVipLevelByPaperId(paperId) {
      try{
        const res = await getAction('/teaching/teachingVip/getVipByPaperId', { paperId: paperId });
        if(res.success){
          this.vipLevel = res.result
          await this.createVipOrder(this.vipLevel.id, this.vipLevel.price)
        }else {
            this.$message.error(res.message)
          }
      }catch(e) {
        console.log(e);
      }
    },

        //购买下单
    async createVipOrder(id,price) {
      try {
        const params = {
          vipId: id,
          payMode: 1,
          orderPrice: price,
        };
        const res = await postAction('/teaching/teachingOrder/createVipOrder', params);
        if (!res.success) {
          message.error(res.message);
          return;
        }
        this.payUrl = res.message;
        this.vipVisible = true;
        this.$nextTick(() => {
          this.generateQRCode();
        });
      } catch (err) {
        message.error(err.message);
      }
    },

        //生成二维码
    generateQRCode() {
      const canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, this.payUrl, { width: 200 }, function (error) {
        if (error) console.error(error);
        console.log('二维码生成成功');
      });
    },
    redoExam(info) {
      let paperId;
      if ("paperId" in info) {
        paperId = info.paperId;
      } else {
        paperId = info.id;
      }
      this.$router.push({
        path: "/examine",
        query: {
          id: paperId,
          departId: info.departId,
        },
      });
    },
    toExam(info) {
      let paperId;
      if ("paperId" in info) {
        paperId = info.paperId;
      } else {
        paperId = info.id;
      }
      this.$router.push({
        path: "/examine",
        query: {
          id: paperId,
          departId: info.departId,
          userPaperId: info.userPaperId,
        },
      });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.to-exam-btn {
  // background: rgb(159, 159, 159);
  // color: white;
}
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
.payment-info {
  margin: 16px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.vip-level,
.vip-price {
  display: block;
  margin-bottom: 8px;
}

.qr-code-container {
  border: 1px solid #f5f5f5;
  height: 300px;
  width: 70%;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.qr-code-header {
  text-align: center;
  margin-bottom: 16px;
}

.wx-logo {
  width: 100px;
  height: 25px;
}

.qr-code-body {
  text-align: center;
}
</style>